import {
  CHANGE_LOGO_EDITING_STATUS,
  HIDE_WAITING_COVER,
  SHOW_WAITING_COVER,
  changeLogoEditingStatus,
} from '../main/actions';

import { canvasActionType } from '../canvas/actions';
import { getLogoEditingStatus } from '../main/selectors';
import { logoEditingStatusEnum } from './constants';
import { userImageActionType } from '../userimage/actions';

const allowedActions = [
  SHOW_WAITING_COVER,
  HIDE_WAITING_COVER,
  canvasActionType.SWITCH_SHOW_WARNING_MESSAGE_CONTAINER,
  userImageActionType.APPLYNOTICE_TOGGLE,
];

const dpiWarningMiddleware =
  ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    const state = getState();
    const editingStatus = getLogoEditingStatus(state).currentStatus;

    // process only in DpiWarningButton status
    if (editingStatus === logoEditingStatusEnum.DpiWarningButton) {
      if (allowedActions.find((x) => x === action.type)) {
        // restore status to None if users cancel AddToCart click
        if (action.type === canvasActionType.SWITCH_SHOW_WARNING_MESSAGE_CONTAINER) {
          next(changeLogoEditingStatus(logoEditingStatusEnum.None));
        }

        return next(action);
      }

      //allow several special actions
      if (
        action.type === CHANGE_LOGO_EDITING_STATUS &&
        (action.payload === logoEditingStatusEnum.DpiWarningContinueToCart ||
          action.payload === logoEditingStatusEnum.None)
      ) {
        return next(action);
      }

      // block all other actions
      return null;
    }

    return next(action);
  };
export default dpiWarningMiddleware;
